export const ru = {
    perWeek: 'в неделю'
};
